import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Link, type LinkProps } from 'react-router'
import { buttonClass, type ButtonLook } from '@/components/console/classes'
import { Icon, type IconName } from '@/components/icons/icon'

function Content({ icon, children }: { icon?: IconName; children?: ReactNode }) {
  return (
    <>
      {icon ? <Icon name={icon} /> : null}
      {children}
    </>
  )
}

interface ButtonLookProps extends ButtonLook {
  /** A leading icon from the console set. */
  icon?: IconName
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, ButtonLookProps {}

/** A console button (`.btn`). `type="button"` unless you say otherwise. */
export function Button({ variant, size, icon, iconOnly, className, type = 'button', children, ...props }: ButtonProps) {
  return (
    <button type={type} className={buttonClass({ variant, size, iconOnly }, className)} {...props}>
      <Content icon={icon}>{children}</Content>
    </button>
  )
}

export interface ButtonLinkProps extends LinkProps, ButtonLookProps {}

/** A react-router link that looks like a console button. */
export function ButtonLink({ variant, size, icon, iconOnly, className, children, ...props }: ButtonLinkProps) {
  return (
    <Link className={buttonClass({ variant, size, iconOnly }, className)} {...props}>
      <Content icon={icon}>{children as ReactNode}</Content>
    </Link>
  )
}
